export const COLORS = {
  primary: '#F75F2B',
  primaryBorder: '#CFCFCF',
  primaryHover: '#E24009',
  primaryPress: 'FCBCA6',
  primaryRGB: '247, 95, 43',
  primaryDisabled: '#FDDED3',
  secondary: '#8566CC',
  secondaryHover: '#5C39AC',
  secondaryRGB: '133, 102, 204',
  separator: '#A28AD8',
  black: '#363636',
  red: '#E62619',
  tertiary: '#63656A',
  inputFocused: '#848484'
}